import { useAppTFunction } from '@retail/app/i18n';
import { CampaignTenantType, useDeleteCampaign } from '@retail/campaign/data-access';
import { BaseCampaignItem, CampaignBase } from '@retail/campaign/types';
import { DeleteDialog } from '@retail/components';
import { useToast } from '@retail/hooks';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
  open: boolean;
  campaign: CampaignBase<BaseCampaignItem>;
  onClose: () => void;
  type: CampaignTenantType;
}

export const CampaignDeleteConfirmationContainer = ({ campaign, open, onClose, type }: Props) => {
  const t = useAppTFunction();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutateAsync: mutateDeleteCampaignAsync, isPending: isLoadingDelete } = useDeleteCampaign({
    campaignId: campaign.id,
    type,
  });

  const handleDeleteCampaign = async () => {
    try {
      await mutateDeleteCampaignAsync({});
      queryClient.invalidateQueries({
        queryKey: ['campaigns'],
      });
      toast.success(t('campaign.messages.deleteCampaign'));
    } catch (error) {
      console.error(error);
      toast.error(t('campaign.error.deleteCampaign'));
    }
  };

  return (
    <DeleteDialog
      isOpen={open}
      dialogTitle={t('campaign.actions.deleteCampaign')}
      message={t('campaign.messages.deleteCampaignInfo', {
        campaignName: campaign.name,
      })}
      loading={isLoadingDelete}
      onDelete={handleDeleteCampaign}
      onClose={onClose}
    />
  );
};
